import React, {useEffect, useState} from 'react';
import './moraexService.css'
import {useLocation} from "react-router-dom";
import HeaderNav from "../../common/header/headerNav/headerNav";
import FooterGray from "../../common/footer/footerGray/footerGray";

const url = 'https://terms.everex.co.kr/projects/moraWeb/service.html'

const MoraexService = () => {
  const location = useLocation()

  const [html, setHtml] = useState('')

  useEffect(() => {
    let xmlhttp = new XMLHttpRequest()
    xmlhttp.onreadystatechange=function() {
      if(xmlhttp.readyState === 4 && xmlhttp.status === 200) {
        setHtml(xmlhttp.responseText)
        return xmlhttp.responseText
      }
    }
    xmlhttp.open('GET', url, true)
    xmlhttp.send()
  }, [])

  return (
    <div className={location.pathname.includes('terms') ? 'moraexServiceFooter' : 'moraexServiceAuth'}>
      { location.pathname.includes('terms') && (
        <>
          <HeaderNav/>
          <div className='AgreementTitle'>
            <h1>MORA (의료진) 서비스 이용약관</h1>
          </div>
        </>
      )}
      <div dangerouslySetInnerHTML={{ __html: html }}></div>
      { location.pathname.includes('terms') && (
        <FooterGray position='relative'/>
      )}
    </div>
  );
}

export default MoraexService